<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tscheduleaccount}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <w-city v-model="dataForm.city" placeholder="城市"  defaultUrl="/sys/operationsconsume/accessToAccess"></w-city>
        </el-form-item>
        <el-form-item>
          <renSelect v-model="dataForm.product" dictType="loan_type" originPage="put" placeholder="产品"></renSelect>
        </el-form-item>
        <el-form-item>
          <el-date-picker
          v-model="dataForm.inputDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="录入日期">
         </el-date-picker>
        </el-form-item>
        

        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
      
        <el-form-item>
          <el-button v-if="$hasPermission('sys:operationsconsume:save')"  type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
       
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"  @sort-change="dataListSortChangeHandle($event,false)" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
       
        <el-table-column prop="platformName" label="平台" header-align="center"  align="center"></el-table-column>
        <el-table-column prop="city" label="城市" header-align="center"  sortable="custom" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品" header-align="center"  align="center"></el-table-column>
       
        <el-table-column prop="totalConsumption" label="总消耗（元）" sortable="custom" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reviewersStatus" label="状态" sortable="custom" header-align="center" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.reviewersStatus == 0">待审核</span>
              <span v-if="scope.row.reviewersStatus == 1">审核通过</span>
              <span v-if="scope.row.reviewersStatus == 2">待修改</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="是否有效" sortable="custom" header-align="center" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.status == 0">无效</span>
              <span v-else>有效</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="inputDate" label="录入时间" sortable="custom" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" sortable="custom" header-align="center" align="center"></el-table-column>
        <el-table-column prop="reviewersDate" label="复核时间" sortable="custom" header-align="center" align="center"></el-table-column>

        <el-table-column prop="creatorName" label="录入人"  header-align="center" align="center"></el-table-column>

        <el-table-column prop="reviewersName" label="复核人"  header-align="center" align="center"></el-table-column>
      
        <el-table-column :label="$t('handle')"  header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.reviewersStatus == 0 && $hasPermission('sys:operationsconsume:audit')" type="text" size="small" @click="editStatus(scope.row,'/sys/operationsconsume/audit',1)">通过</el-button>
            <el-button v-if="scope.row.reviewersStatus == 0 && $hasPermission('sys:operationsconsume:audit')" type="text" size="small" @click="editStatus(scope.row,'/sys/operationsconsume/audit',2)">不通过</el-button>
            <el-button
             v-if="scope.row.reviewersStatus == 2 && $hasPermission('sys:operationsconsume:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './operationsconsume-add-or-update.vue'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/operationsconsume/page',
        getDataListIsPage: true,
        exportURL: '/sys/operationsconsume/export',
        deleteURL: '/sys/operationsconsume',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        inputDate: '',
        product: '',
        city: '',
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
